import type { PostPlanToPatientApiQuery } from "@/Modules/Models/Api/Plan";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import * as Sentry from "@sentry/capacitor";

import { postPlanToPatient } from "@/Services/TherapyApi/Plans";

import usePlanStore from "@/Modules/Plan/Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

function postPlanToPatientAH(infoPostPlan: PostPlanToPatientApiQuery) {
  const planStore = usePlanStore();
  const appStore = useAppStore();

  planStore.loading = true;

  return postPlanToPatient(infoPostPlan)
    .then(() => {
      appStore.showSnackbar({
        type: NotificationType.INFO,
        message: "private_plans.maintenance_plan_has_been_sent",
      });
    })
    .catch((e) => {
      danger(e);
      Sentry.captureException(e);
    })
    .finally(() => {
      planStore.loading = false;
    });
}

export default postPlanToPatientAH;
